import AbstractManageable from './abstract-manageable';
import Chapter            from './chapter';
import Class              from './class';
import Instruction        from './instruction';
import User               from './user';

export default class Account extends AbstractManageable {
	static SECTION_OPERATION = 'OPERATION';
	static SECTION_INVESTMENT = 'INVESTMENT';
	
	/**
	 * 
	 * @param {Number}      id 
	 * @param {String}      number 
	 * @param {String}      label 
	 * @param {Boolean}     operation 
	 * @param {Boolean}     expense 
	 * @param {Boolean}     receipts 
	 * @param {Boolean}     template 
	 * @param {Date}        addedOn 
	 * @param {Date}        removedOn 
	 * @param {Instruction} instruction 
	 * @param {Class}       instructionClass 
	 * @param {Chapter}     defaultChapter 
	 * @param {User}        creator 
	 * @param {Date}        createdAt 
	 * @param {User}        updater 
	 * @param {Date}        updatedAt 
	 */
	constructor(
			id,
			number,
			label,
			operation,
			expense,
			receipts,
			template,
			addedOn,
			removedOn,
			instruction,
			instructionClass,
			defaultChapter,
			creator,
			createdAt,
			updater,
			updatedAt) {
		super(creator, createdAt, updater, updatedAt);

		this.addedOn          = addedOn;
		this.defaultChapter   = defaultChapter;
		this.template         = template;
		this.expense          = expense;
		this.id               = id;
		this.instruction      = instruction;
		this.instructionClass = instructionClass;
		this.label            = label;
		this.number           = number;
		this.operation        = operation;
		this.receipts         = receipts;
		this.removedOn        = removedOn;
	}

	static createFromJson = (json) => {
		if (!json) return null;

		const id               = json.id;
		const number           = json.number;
		const label            = json.label;
		const operation        = json.operation;
		const expense          = json.expense;
		const receipts         = json.receipts;
		const template         = json.template;
		const addedOn          = new Date(json.addedOn);
		const removedOn        = new Date(json.removedOn);
		const instruction      = Instruction.createFromJson(json.instruction);
		const instructionClass = Class.createFromJson(json.instructionClass);
		const defaultChapter   = json.defaultChapter;
		const creator          = User.createFromJson(json.creator);
		const createdAt        = new Date(json.createdAt);
		const updater          = User.createFromJson(json.updater);
		const updatedAt        = new Date(json.updatedAt);

		return new Account(
			id,
			number,
			label,
			operation,
			expense,
			receipts,
			template,
			addedOn,
			removedOn,
			instruction,
			instructionClass,
			defaultChapter,
			creator,
			createdAt,
			updater,
			updatedAt);
	}
}


// WEBPACK FOOTER //
// ./src/model/account.js